









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as XLSX from 'xlsx';

@Component
export default class SheetSelect extends Vue {
  selectedSheet: string = '';

  @Prop({ required: true, default: () => [] }) private sheetNames: string[];
  @Prop() private value: string;
  
  @Watch('value', { immediate: true }) onValueChanged() {
    this.selectedSheet = this.value;
  }

  selectSheet(sheet: string) {
    this.$emit('input', sheet);
  }

}
